import isString from 'lodash/isString'
import { User } from 'oidc-react'

import { AuthFields } from './constants'

export const formatUserPrivileges = <Permission>(userData?: User | null): Permission[] => {
	if (!userData) {
		return []
	}

	const privilegesData = userData.profile?.[AuthFields.privileges]

	if (!privilegesData) {
		return []
	}

	if (isString(privilegesData)) {
		return [privilegesData as Permission]
	}

	return privilegesData as Permission[]
}
